import { IMenu } from '../interfaces/menu';

export const groupMenuItemsBySection = (items: IMenu[]): { [key: string]: IMenu[] } => {
	return items.reduce(
		(result, item) => {
			(result[item.sectionTitle] = result[item.sectionTitle] || []).push(item);
			return result;
		},
		{} as { [key: string]: IMenu[] },
	);
};
